import React from "react";
import banner2 from '../assets/banner2.png';


const Media = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans">

      {/* HERO */}
       <section
        className="relative py-16 md:py-24 text-center overflow-hidden"
        style={{
          backgroundImage: `url(${banner2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        
      <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
         Media
        </h3>
        <div
          className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
          style={{
            background:
              "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
          }}
        />
      </section>
      
      
<section className="py-32 text-center">
        <h2 className="font-syne text-4xl md:text-5xl text-slate-700 font-medium tracking-tight">
          Coming Soon
        </h2>
      </section>
     
    

    </div>
  );
};

export default Media;

